import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { EmpDetailsService } from '../../../Model/EmpProfileDetails/emp-details.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { Subject } from 'rxjs';
import { ViewProfileRequestDetailComponent } from '../view-profile-request-detail/view-profile-request-detail.component';
import { AnyARecord } from 'dns';

@Component({
  selector: 'app-profile-details-request',
  standalone: true,
  imports: [CommonModule, NgSelectModule, RouterModule, DataTablesModule, FormsModule, LoaderComponent, JsonPipe, NgbModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './profile-details-request.component.html',
  styleUrl: './profile-details-request.component.scss'
})
export class ProfileDetailsRequestComponent {
  isDisabled: boolean = false;
  public User: any = null;
  acNoLength: number = 0;
  Marital: any[] = [];
  //Gender: any[] = [];
  Bank: any[] = [];
  BankBranch: any[] = [];
  PaymentModes: any[] = [];
  StateLoad: any[] = [];
  DistrictLoad: any[] = [];
  TalukaLoad: any[] = [];
  QualificationLoad: any[] = [];
  RelationshipLoad: any[] = [];
  AddressTypeLoad: any[] = [];
  DocumentLoad: any[] = [];
  NomineeDistrictLoad: any[] = [];
  NomineeTalukaLoad: any[] = [];
  PermanentDistrictLoad: any[] = [];
  PermanentTalukaLoad: any[] = [];
  ConfirmBankAccountNo: any = null;

  BasicDetail = {
    SelectType: 'I',
    EmpMasterID: null,
    FirstName: null as any,
    MiddleName: null as any,
    LastName: null as any,
    GenderID: null as any,
    BirthDate: null as any,
    BirthDateObj: null as any,
    FatherHusbandName: null as any,
    MaritalStatusID: null,
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  BankFormDetail = {
    SelectType: 'I',
    EmpMasterID: null,
    BankBranchID: null,
    BankAccountNo: null,
    PaymentMode: null,
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null,
    BankID: null,
    IFSCcode: null
  }
  CurrentAddress = {
    SelectType: 'I',
    EmpMasterID: null,
    LocalAddress1: null as any,
    LocalAddress2: null as any,
    VillageCity: null as any,
    StateID: null,
    DistrictID: null,
    TalukaTehsilID: null,
    Pincode: null as any,
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  PermanentAddress = {
    SelectType: 'I',
    EmpMasterID: null,
    NativeAddress1: null as any,
    NativeAddress2: null as any,
    VillageCity: null as any,
    StateID: null,
    DistrictID: null,
    TalukaTehsilID: null,
    Pincode: null as any,
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  Qualification = {
    SelectType: 'I',
    EmpMasterID: null,
    ESS_EmpProfile_QualificationDetails: [{
      EmpQualificationDetailsID: null,
      QualificationID: null,
      UniversityBoard: null,
      YearOfPassing: null,
      Percentage: null,
      GradeClass: null,
      QualificationName: null
    }],
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  Nominee = {
    SelectType: 'I',
    EmpMasterID: null,
    ESS_EmpProfile_NomineeDetails: [{
      EmpNomineeDetailsID: null,
      Name: null as any,
      Address1: null,
      Address2: null,
      RelationshipID: null,
      Relationship: null,
      VillageCity: null,
      StateID: null,
      State: null,
      DistrictID: null,
      District: null,
      TalukaTehsilID: null,
      Taluka: null,
      PinCode: null,
      BirthDate: null as any,
      Share: null,
      Guardian: null
    }],
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  Dependent = {
    SelectType: 'I',
    EmpMasterID: null,
    ESS_EmpProfile_DependentDetails: [{
      EmpDependentDetailsID: null,
      Name: null as any,
      AddressTypeID: null,
      DateOfBirth: null,
      RelationshipID: null,
      AddressTypeName: null,
      Relationship: null
    }],
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  Document = {
    SelectType: 'I',
    EmpMasterID: null,
    ESS_EmpProfile_DocumentDetails: [{
      DocumentTypeID: null,
      FileName: null,
      DocumentNumber: null
    }],
    UserId: null,
    allowEdit: null,
    ESS_EmpProfileUpdateRequestID: null
  }
  Filter = {
    QualificationID: null,
    UniversityBoard: null as any,
    YearOfPassing: null,
    Percentage: null as any,
    GradeClass: null as any,
    QualificationName: null
  }
  Filter1 = {
    EmpNomineeDetailsID: null,
    Name: null as any,
    Address1: null as any,
    Address2: null as any,
    RelationshipID: null,
    Relationship: null,
    VillageCity: null as any,
    StateID: null,
    State: null,
    DistrictID: null,
    District: null,
    TalukaTehsilID: null,
    Taluka: null,
    PinCode: null as any,
    BirthDate: null as any,
    BirthDateObj: null as any,
    Share: null as any,
    Guardian: null as any
  }
  Filter3 = {
    EmpDependentDetailsID: null,
    Name: null as any,
    AddressTypeID: null,
    DateOfBirth: null as any,
    DateOfBirthObj: null as any,
    RelationshipID: null,
    AddressTypeName: null,
    Relationship: null
  }
  Filter4 = {
    DocumentTypeID: null,
    FileName: null,
    DocumentNumber: null
  }
  MaxDate: any = null
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private combo: ComboService,
    private tooltip: TooltipService,
    private empprofile: EmpDetailsService
  ) {
    this.User = this.sessionService.GetUserDetails();
    this.common.getPageRights();
    this.BasicDetail.EmpMasterID = this.User.UserId
    this.BasicDetail.UserId = this.User.UserId

    this.BankFormDetail.UserId = this.User.UserId
    this.BankFormDetail.EmpMasterID = this.User.UserId

    this.CurrentAddress.UserId = this.User.UserId
    this.CurrentAddress.EmpMasterID = this.User.UserId

    this.PermanentAddress.UserId = this.User.UserId
    this.PermanentAddress.EmpMasterID = this.User.UserId

    this.Qualification.UserId = this.User.UserId
    this.Qualification.EmpMasterID = this.User.UserId

    this.Nominee.UserId = this.User.UserId
    this.Nominee.EmpMasterID = this.User.UserId

    this.Dependent.UserId = this.User.UserId
    this.Dependent.EmpMasterID = this.User.UserId

    this.Document.UserId = this.User.UserId
    this.Document.EmpMasterID = this.User.UserId
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit(): void {
    this.ComboLoad('Marital');
    //this.ComboLoad('Gender');
    this.ComboLoad('Bank');
    this.ComboLoad('PaymentMode');
    this.ComboLoad('State');
    this.ComboLoad('Qualification');
    this.ComboLoad('Relationship');
    this.ComboLoad('Address');
    //this.ComboLoad('Document');
    this.getData();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          //this.Filter1.BirthDateObj = this.dateFormate.parse(response.Table[0].RegistrationDate)
          this.MaxDate = this.dateFormate.parse(response.Table[0].RegistrationDate);
          //console.log(this.Filter1.BirthDateObj);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'StateId': (Combotype == 'District') ? this.CurrentAddress.StateID : 0,
      'DistrictId': (Combotype == 'Taluka') ? this.CurrentAddress.DistrictID : 0,
      'BankId': (Combotype == 'BankBranch') ? this.BankFormDetail.BankID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Marital') {
          this.Marital = response.ComboLoad;
        }
        // else if (Combotype == 'Gender') {
        //   this.Gender = response.ComboLoad;
        // } 
        else if (Combotype == 'Bank') {
          this.Bank = response.ComboLoad;
        } else if (Combotype == 'PaymentMode') {
          this.PaymentModes = response.ComboLoad;
        } else if (Combotype == 'State') {
          this.StateLoad = response.ComboLoad;
        } else if (Combotype == 'District') {
          this.DistrictLoad = response.ComboLoad;
        } else if (Combotype == 'Taluka') {
          this.TalukaLoad = response.ComboLoad;
        } else if (Combotype == 'Qualification') {
          this.QualificationLoad = response.ComboLoad;
        } else if (Combotype == 'Relationship') {
          this.RelationshipLoad = response.ComboLoad;
        } else if (Combotype === 'Address') {
          this.AddressTypeLoad = response.ComboLoad;
        } else if (Combotype == 'BankBranch') {
          this.BankBranch = response.ComboLoad;
        }
        // else if(Combotype ==='Document'){
        //   this.DocumentTypeLoad = response.ComboLoad;
        //   this.isDisabled = false
        // }
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  ComboLoad2(Combotype: String, Combotype2: string = '', index = 0) {
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'StateId': (Combotype == 'District') ? this.Filter1.StateID : 0,
      'DistrictId': (Combotype == 'Taluka') ? this.Filter1.DistrictID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'District') {
          this.NomineeDistrictLoad = response.ComboLoad;
        } else if (Combotype == 'Taluka') {
          this.NomineeTalukaLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  ComboLoad3(Combotype: String, Combotype2: string = '', index = 0) {
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'StateId': (Combotype == 'District') ? this.PermanentAddress.StateID : 0,
      'DistrictId': (Combotype == 'Taluka') ? this.PermanentAddress.DistrictID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'District') {
          this.PermanentDistrictLoad = response.ComboLoad;
        } else if (Combotype == 'Taluka') {
          this.PermanentTalukaLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Save(type: string) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save ?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.isDisabled = true;
          if (type === 'PersonalDetail') {
            this.PersonalDetail();
          } else if (type === 'BankDetail') {
            this.BankDetails();
          } else if (type === 'CurrentAddress') {
            this.CurrentAddressDetails();
          } else if (type === 'PermanentAddress') {
            this.Permanent();
          } else if (type === 'QualificationDetail') {
            this.QualificationInsert();
          } else if (type === 'NomineeDetail') {
            this.NomineeInsert();
          } else if (type === 'MemberDetail') {
            this.DependentInsert();
          } else if (type === 'DocumentDetail') {
            this.isDisabled = true;
            this.DocumentInsert();
          }
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      this.isDisabled = false;
    });
  }
  PersonalDetail() {
    this.isDisabled = true;
    if (this.BasicDetail.GenderID === null || this.BasicDetail.GenderID === '') {
      this.toast.show({ message: 'Please select gender!', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return;
    }
    this.BasicDetail.FirstName = this.common.ToUpperCase(this.BasicDetail.FirstName);
    this.BasicDetail.MiddleName = this.common.ToUpperCase(this.BasicDetail.MiddleName)
    this.BasicDetail.LastName = this.common.ToUpperCase(this.BasicDetail.LastName)
    this.BasicDetail.FatherHusbandName = this.common.ToUpperCase(this.BasicDetail.FatherHusbandName)
    this.BasicDetail.BirthDate = this.dateFormate.format(this.BasicDetail.BirthDateObj);
    this.empprofile.EmpProfile_Details(this.BasicDetail).subscribe({
      next: (data) => {
        if (data.Error_Code == '568') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  BankDetails() {
    this.isDisabled = true;
    if (this.BankFormDetail.PaymentMode !== 1 && (this.BankFormDetail.BankAccountNo !== this.ConfirmBankAccountNo)) {
      this.toast.show({ message: 'Please enter correct bank account no.', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return
    }
    if (this.BankFormDetail.PaymentMode === 1) {
      this.BankFormDetail.BankBranchID = null;
      this.BankFormDetail.BankAccountNo = null;
    }
    this.empprofile.ESS_EmpProfile_BankDetails(this.BankFormDetail).subscribe({
      next: (data) => {
        if (data.Error_Code == '562') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  CurrentAddressDetails() {
    if (this.CurrentAddress.StateID !== null) {
      if (this.CurrentAddress.DistrictID == null || this.CurrentAddress.DistrictID == '') {
        this.toast.show({ message: 'Please select district', type: toastTypeEnum.warning });
        this.isDisabled = false;
        return
      }
      if (this.CurrentAddress.TalukaTehsilID == null || this.CurrentAddress.TalukaTehsilID == '') {
        this.toast.show({ message: 'Please select taluka', type: toastTypeEnum.warning });
        this.isDisabled = false;
        return
      }
    }
    if (this.CurrentAddress.Pincode > 0 && this.CurrentAddress.Pincode.length < 6) {
      this.toast.show({ message: 'Please enter proper pincode', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return
    }
    this.isDisabled = true;
    this.empprofile.EmpProfile_CurrentAddressDetails(this.CurrentAddress).subscribe({
      next: (data) => {
        if (data.Error_Code == '563') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  Permanent() {
    if (this.PermanentAddress.StateID !== null) {
      if (this.PermanentAddress.DistrictID == null || this.PermanentAddress.DistrictID == '') {
        this.toast.show({ message: 'Please select district', type: toastTypeEnum.warning });
        this.isDisabled = false;
        return
      }
      if (this.PermanentAddress.TalukaTehsilID == null || this.PermanentAddress.TalukaTehsilID == '') {
        this.toast.show({ message: 'Please select taluka', type: toastTypeEnum.warning });
        this.isDisabled = false;
        return
      }
    }
    if (this.PermanentAddress.Pincode > 0 && this.PermanentAddress.Pincode.length < 6) {
      this.toast.show({ message: 'Please enter proper pincode', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return
    }
    this.isDisabled = true;
    this.empprofile.EmpProfile_PermanentAddress(this.PermanentAddress).subscribe({
      next: (data) => {
        if (data.Error_Code == '564') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  QualificationInsert() {
    this.isDisabled = true;
    this.Qualification.ESS_EmpProfile_QualificationDetails.forEach((qualification: any) => {
      delete qualification.QualificationName;
    });
    if (this.Qualification.ESS_EmpProfile_QualificationDetails.length <= 0) {
      this.toast.show({ message: 'Please add atleast 1 qualification!', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return;
    }
    this.empprofile.EmpProfile_QualificationDetails(this.Qualification).subscribe({
      next: (data) => {
        if (data.Error_Code == '569') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  NomineeInsert() {
    this.isDisabled = true;
    this.Nominee.ESS_EmpProfile_NomineeDetails.forEach((detail: any) => {
      delete detail.Relationship;
      delete detail.State;
      delete detail.District;
      delete detail.Taluka;
    });
    if (this.Nominee.ESS_EmpProfile_NomineeDetails.length <= 0) {
      this.toast.show({ message: 'Please add atleast 1 nominee!', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return;
    }
    this.empprofile.EmpProfile_NomineeDetails(this.Nominee).subscribe({
      next: (data) => {
        if (data.Error_Code == '570') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  DependentInsert() {
    this.isDisabled = true;
    this.Dependent.ESS_EmpProfile_DependentDetails.forEach((detail: any) => {
      delete detail.AddressTypeName;
      delete detail.Relationship;
    });
    if (this.Dependent.ESS_EmpProfile_DependentDetails.length <= 0) {
      this.toast.show({ message: 'Please add atleast 1 dependent!', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return;
    }
    this.empprofile.EmpProfile_DependentDetails(this.Dependent).subscribe({
      next: (data) => {
        if (data.Error_Code == '572') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  DocumentInsert() {
    const selectedItems = this.DocumentLoad.filter(item => item.selected);
    if (selectedItems.length === 0) {
      this.toast.show({ message: 'Please select at least 1 document!', type: toastTypeEnum.warning });
      this.isDisabled = false;
      return;
    }
    for (const site of this.DocumentLoad) {
      if (site.selected) {
        if ((site.FileName && !site.DocumentNumber) || (!site.FileName && site.DocumentNumber)) {
          this.toast.show({
            message: 'Please enter Document Number and upload a file for selected documents.',
            type: toastTypeEnum.warning
          });
          this.isDisabled = false;
          return;
        }
      }
    } this.isDisabled = true;
    this.DocumentLoad.forEach(site => {
      if (site.selected && site.FileName) {
        this.Document.ESS_EmpProfile_DocumentDetails.push({
          DocumentTypeID: site.DocumentTypeID,
          FileName: site.FileName,
          DocumentNumber: site.DocumentNumber
        });
      }
    });
    this.isDisabled = true;
    this.empprofile.EmpProfile_DocumentDetails(this.Document).subscribe({
      next: (data) => {
        if (data.Error_Code == '571') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.getData();
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
    this.isDisabled = false;
  }
  getData() {
    this.Qualification.ESS_EmpProfile_QualificationDetails = [];
    this.Nominee.ESS_EmpProfile_NomineeDetails = [];
    this.Dependent.ESS_EmpProfile_DependentDetails = [];
    this.Document.ESS_EmpProfile_DocumentDetails = [];
    this.isDisabled = true;
    this.empprofile.GetEmployeeDetails({ Type: 'GetAllDetails', EmpMasterID: this.User.UserId }).subscribe({
      next: (data) => {
        if (data.Table.length > 0) {
          //this.AllDetails.BasicDetail = data.Table;
          this.BasicDetail.FirstName = data.Table[0].FirstName;
          this.BasicDetail.MiddleName = data.Table[0].MiddleName;
          this.BasicDetail.LastName = data.Table[0].Surname;
          this.BasicDetail.FatherHusbandName = data.Table[0].FatherHusbandName;
          this.BasicDetail.BirthDateObj = this.dateFormate.parse(data.Table[0].DOB);   // this.dateFormate.parse(data.Table[0].DOB);
          this.BasicDetail.MaritalStatusID = data.Table[0].MartialStatusID;
          this.BasicDetail.GenderID = data.Table[0].GenderID;
          this.BasicDetail.allowEdit = data.Table[0].allowEdit;
          this.BasicDetail.ESS_EmpProfileUpdateRequestID = data.Table[0].ESS_EmpProfileUpdateRequestID
        }
        if (data.Table1.length > 0) {
          //this.AllDetails.Current = data.Table1;
          this.CurrentAddress.LocalAddress1 = data.Table1[0].AddressLine1;
          this.CurrentAddress.LocalAddress2 = data.Table1[0].AddressLine2;
          this.CurrentAddress.VillageCity = data.Table1[0].Village;
          this.CurrentAddress.StateID = data.Table1[0].StateID;
          this.ComboLoad('District');
          this.CurrentAddress.DistrictID = data.Table1[0].DistrictID;
          this.ComboLoad('Taluka')
          this.CurrentAddress.TalukaTehsilID = data.Table1[0].TalukaID;
          this.CurrentAddress.Pincode = data.Table1[0].Pincode;
          this.CurrentAddress.allowEdit = data.Table1[0].allowEdit;
          this.CurrentAddress.ESS_EmpProfileUpdateRequestID = data.Table1[0].ESS_EmpProfileUpdateRequestID
        }
        if (data.Table2.length > 0) {
          //this.AllDetails.Permanent = data.Table2;
          this.PermanentAddress.NativeAddress1 = data.Table2[0].AddressLine1;
          this.PermanentAddress.NativeAddress2 = data.Table2[0].AddressLine2;
          this.PermanentAddress.VillageCity = data.Table2[0].Village;
          this.PermanentAddress.StateID = data.Table2[0].StateID;
          this.ComboLoad3('District');
          this.PermanentAddress.DistrictID = data.Table2[0].DistrictID;
          this.ComboLoad3('Taluka');
          this.PermanentAddress.TalukaTehsilID = data.Table2[0].TalukaID;
          this.PermanentAddress.Pincode = data.Table2[0].Pincode;
          this.PermanentAddress.allowEdit = data.Table2[0].allowEdit;
          this.PermanentAddress.ESS_EmpProfileUpdateRequestID = data.Table2[0].ESS_EmpProfileUpdateRequestID
        }
        if (data.Table3.length > 0) {
          //this.AllDetails.Qualification = data.Table3;
          this.Qualification.allowEdit = data.Table3[0].allowEdit;
          this.Qualification.ESS_EmpProfileUpdateRequestID = data.Table3[0].ESS_EmpProfileUpdateRequestID
          data.Table3.forEach((element: any, index: number) => {
            this.Qualification.ESS_EmpProfile_QualificationDetails.push({
              EmpQualificationDetailsID: element.EmpQualificationDetailsID,
              QualificationID: element.DegreeID,
              UniversityBoard: element.UniversityBoard,
              YearOfPassing: element.YearOfPassing,
              Percentage: element.Percentage,
              GradeClass: element.GradeClass,
              QualificationName: element.Degree
            });
          });
        }
        if (data.Table4.length > 0) {
          //this.AllDetails.Nominee = data.Table4;
          this.Nominee.allowEdit = data.Table4[0].allowEdit;
          this.Nominee.ESS_EmpProfileUpdateRequestID = data.Table4[0].ESS_EmpProfileUpdateRequestID
          data.Table4.forEach((element: any, index: number) => {
            this.Nominee.ESS_EmpProfile_NomineeDetails.push({
              EmpNomineeDetailsID: element.EmpNomineeDetailsID,
              Name: element.NomineeName,
              Address1: element.AddressLine1,
              Address2: element.AddressLine2,
              RelationshipID: element.RelationshipID,
              Relationship: element.Relationship,
              VillageCity: element.Village,
              StateID: element.StateID,
              State: element.State,
              DistrictID: element.DistrictID,
              District: element.District,
              TalukaTehsilID: element.TalukaID,
              Taluka: element.Taluka,
              PinCode: element.Pincode,
              BirthDate: element.DOB,
              Share: element.Share,
              Guardian: element.GuardianName
            });
          });
        }
        if (data.Table5.length > 0) {
          //this.AllDetails.Dependent = data.Table5;
          this.Dependent.allowEdit = data.Table5[0].allowEdit;
          this.Dependent.ESS_EmpProfileUpdateRequestID = data.Table5[0].ESS_EmpProfileUpdateRequestID
          data.Table5.forEach((element: any, index: number) => {
            this.Dependent.ESS_EmpProfile_DependentDetails.push({
              EmpDependentDetailsID: element.EmpDependentDetailsID,
              Name: element.MemberName,
              AddressTypeID: element.Address,
              DateOfBirth: element.DOB,
              RelationshipID: element.RelationshipID,
              AddressTypeName: element.AddressTypeName,
              Relationship: element.Relationship
            });
          });
        }
        if (data.Table7.length > 0) {
          //this.ComboLoad('Bank');
          //this.AllDetails.Bank = data.Table7;
          this.BankFormDetail.BankID = data.Table7[0].BankID;
          this.ComboLoad('BankBranch');
          this.BankFormDetail.BankBranchID = data.Table7[0].BankBranchMasterID
          this.BankFormDetail.IFSCcode = data.Table7[0].IFSCode
          this.BankFormDetail.PaymentMode = data.Table7[0].PaymentModeMasterID
          this.BankFormDetail.BankAccountNo = data.Table7[0].BankAccountNo
          this.ConfirmBankAccountNo = data.Table7[0].BankAccountNo 
          this.BankFormDetail.allowEdit = data.Table7[0].allowEdit;
          this.BankFormDetail.ESS_EmpProfileUpdateRequestID = data.Table7[0].ESS_EmpProfileUpdateRequestID
        }
        // if (data.Table6.length > 0) {
        //   //this.AllDetails.DocumentDetail = data.Table6;
        //   this.Document.allowEdit = data.Table6[0].allowEdit;
        //   this.Document.ESS_EmpProfileUpdateRequestID = data.Table6[0].ESS_EmpProfileUpdateRequestId
        //   this.DocumentLoad = data.Table6;
        //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //     dtInstance.destroy();
        //     this.dtTrigger.next(null);
        //   });
        // }
        if (data.Table6.length > 0) {
          // Setting the other document details
          this.Document.allowEdit = data.Table6[0].allowEdit;
          this.Document.ESS_EmpProfileUpdateRequestID = data.Table6[0].ESS_EmpProfileUpdateRequestId;
          this.DocumentLoad = data.Table6;

          // Set the checkbox to true if FileNamelink is present (i.e., not empty)
          this.DocumentLoad.forEach((site) => {
            if (site.FileNamelink && site.FileNamelink !== '') {
              site.selected = true; // Check the checkbox if there's a FileNamelink
            } else {
              site.selected = false; // Make sure it's unchecked if there's no FileNamelink
            }
          });

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }


        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  addData(type: string) {
    if (type === 'Qualification') {
      if (this.Filter.QualificationID === null || this.Filter.QualificationID === '') {
        this.toast.show({ message: 'Please select Qualification!', type: toastTypeEnum.warning });
        return;
      }
      const isQualificationPresent = this.Qualification.ESS_EmpProfile_QualificationDetails.some(
        qualification => qualification.QualificationID === this.Filter.QualificationID
      );
      if (isQualificationPresent) {
        this.toast.show({ message: 'This Qualification is already added!', type: toastTypeEnum.warning });
        return;
      }
      if (this.Filter.Percentage !== null || this.Filter.Percentage !== '') {
        //let numericValue = this.Filter.Percentage !== null ? this.Filter.Percentage.replace('%', '') : 0;
        const numericValueFloat = this.Filter.Percentage !== '' ? parseFloat(this.Filter.Percentage) : 0;
        if (numericValueFloat < 0 || numericValueFloat > 100) {
          this.toast.show({ message: 'Please enter percentage between 0-100!', type: toastTypeEnum.warning });
          return;
        }
      }
      const newQualification = {
        EmpQualificationDetailsID: null,
        QualificationID: this.Filter.QualificationID,
        UniversityBoard: this.Filter.UniversityBoard,
        YearOfPassing: this.Filter.YearOfPassing,
        Percentage: this.Filter.Percentage,
        GradeClass: this.Filter.GradeClass,
        QualificationName: this.Filter.QualificationName
      };
      this.Qualification.ESS_EmpProfile_QualificationDetails.push(newQualification);
      this.Filter = {
        QualificationID: null,
        UniversityBoard: null,
        YearOfPassing: null,
        Percentage: null,
        GradeClass: null,
        QualificationName: null
      };
    } else if (type === 'Nominee') {
      if (this.Filter1.Name === null || this.Filter1.Name.trim() === '') {
        this.toast.show({ message: 'Please enter name!', type: toastTypeEnum.warning });
        return;
      }
      const isNamePresent = this.Nominee.ESS_EmpProfile_NomineeDetails.some(
        nomineename => this.common.ToLowerCase(nomineename.Name) === this.common.ToLowerCase(this.Filter1.Name.trim())
      );
      if (isNamePresent) {
        this.toast.show({ message: 'This Name is already added!', type: toastTypeEnum.warning });
        return;
      }
      if (this.Filter1.RelationshipID === null || this.Filter1.RelationshipID === '') {
        this.toast.show({ message: 'Please select relationship!', type: toastTypeEnum.warning });
        return;
      }
      if (this.Filter1.StateID !== null) {
        if (this.Filter1.DistrictID == null || this.Filter1.DistrictID == '') {
          this.toast.show({ message: 'Please select district', type: toastTypeEnum.warning });
          this.isDisabled = false;
          return
        }
        if (this.Filter1.TalukaTehsilID == null || this.Filter1.TalukaTehsilID == '') {
          this.toast.show({ message: 'Please select taluka', type: toastTypeEnum.warning });
          this.isDisabled = false;
          return
        }
      }
      if (this.Filter1.PinCode > 0 && this.Filter1.PinCode.length < 6) {
        this.toast.show({ message: 'Please enter proper pincode', type: toastTypeEnum.warning });
        this.isDisabled = false;
        return
      }
      if (!this.Filter1.BirthDateObj) {
        this.toast.show({ message: 'Please enter Date of Birth!', type: toastTypeEnum.warning });
        return;
      }
      if (this.Filter1.Share === null || this.Filter1.Share === '') {
        this.toast.show({ message: 'Please enter Share!', type: toastTypeEnum.warning });
        return;
      }
      if (this.Filter1.Share !== null || this.Filter1.Share !== '') {
        //let numericValue = this.Filter.Percentage !== null ? this.Filter.Percentage.replace('%', '') : 0;
        const numericValueFloat = this.Filter1.Share !== '' ? parseFloat(this.Filter1.Share) : 0;
        if (numericValueFloat < 0 || numericValueFloat > 100) {
          this.toast.show({ message: 'Please enter share between 0-100!', type: toastTypeEnum.warning });
          return;
        }
      }
      const totalShare = this.Nominee.ESS_EmpProfile_NomineeDetails.reduce((sum, nominee) => {
        return sum + (nominee.Share ? parseFloat(nominee.Share) : 0);
      }, 0);

      // Check if the new nominee's share will make the total share exceed 100
      const newNomineeShare = this.Filter1.Share !== null ? parseFloat(this.Filter1.Share) : 0;
      if (totalShare + newNomineeShare > 100) {
        this.toast.show({ message: 'Total share cannot exceed 100%', type: toastTypeEnum.warning });
        return;
      }
      this.Filter1.BirthDate = this.dateFormate.format(this.Filter1.BirthDateObj);
      const newNominee = {
        EmpNomineeDetailsID: null,
        Name: this.Filter1.Name,
        Address1: this.Filter1.Address1,
        Address2: this.Filter1.Address2,
        RelationshipID: this.Filter1.RelationshipID,
        Relationship: this.Filter1.Relationship,
        VillageCity: this.Filter1.VillageCity,
        StateID: this.Filter1.StateID,
        State: this.Filter1.State,
        DistrictID: this.Filter1.DistrictID,
        District: this.Filter1.District,
        TalukaTehsilID: this.Filter1.TalukaTehsilID,
        Taluka: this.Filter1.Taluka,
        PinCode: this.Filter1.PinCode,
        BirthDate: this.Filter1.BirthDate,
        Share: this.Filter1.Share,
        Guardian: this.Filter1.Guardian
      };
      this.Nominee.ESS_EmpProfile_NomineeDetails.push(newNominee);
      this.Filter1 = {
        EmpNomineeDetailsID: null,
        Name: null,
        Address1: null,
        Address2: null,
        RelationshipID: null,
        Relationship: null,
        VillageCity: null,
        StateID: null,
        State: null,
        DistrictID: null,
        District: null,
        TalukaTehsilID: null,
        Taluka: null,
        PinCode: null,
        BirthDate: null,
        BirthDateObj: null,
        Share: null,
        Guardian: null
      };
    } else if (type === 'Dependent') {
      if (this.Filter3.Name === null || this.Filter3.Name.trim() === '') {
        this.toast.show({ message: 'Please enter name!', type: toastTypeEnum.warning });
        return;
      }
      const isNamePresent = this.Dependent.ESS_EmpProfile_DependentDetails.some(
        nomineename => this.common.ToLowerCase(nomineename.Name) === this.common.ToLowerCase(this.Filter3.Name.trim())
      );
      if (isNamePresent) {
        this.toast.show({ message: 'This Name is already added!', type: toastTypeEnum.warning });
        return;
      }
      if (this.Filter3.RelationshipID === null || this.Filter3.RelationshipID === '') {
        this.toast.show({ message: 'Please select relationship!', type: toastTypeEnum.warning });
        return;
      }
      this.Filter3.DateOfBirth = this.dateFormate.format(this.Filter3.DateOfBirthObj);
      const newdependent = {
        EmpDependentDetailsID: null,
        Name: this.Filter3.Name,
        AddressTypeID: this.Filter3.AddressTypeID,
        DateOfBirth: this.Filter3.DateOfBirth,
        RelationshipID: this.Filter3.RelationshipID,
        Relationship: this.Filter3.Relationship,
        AddressTypeName: this.Filter3.AddressTypeName
      };
      this.Dependent.ESS_EmpProfile_DependentDetails.push(newdependent);
      this.Filter3 = {
        EmpDependentDetailsID: null,
        Name: null,
        AddressTypeID: null,
        DateOfBirth: null,
        DateOfBirthObj: null,
        RelationshipID: null,
        Relationship: null,
        AddressTypeName: null
      };
    }
  }
  deleteRow(index: number, type: string): void {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to Delete?'

    modalRef.result.then((result: any) => {
      if (result) {
        if (type === 'qualification') {
          this.Qualification.ESS_EmpProfile_QualificationDetails.splice(index, 1);
        } else if (type === 'nominee') {
          this.Nominee.ESS_EmpProfile_NomineeDetails.splice(index, 1);
        } else if (type === 'Dependent') {
          this.Dependent.ESS_EmpProfile_DependentDetails.splice(index, 1);
        }
      }
    }).catch(() => {

    });
  }
  viewFileLink(link: any) {
    window.open(link, '_blank');
  }
  selectAll(event: any) {
    const isChecked = event.target.checked;
    this.DocumentLoad.forEach((shift) => {
      shift.selected = isChecked;
    });
  }
  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }
  triggerFileInput(index: number) {
    const fileInput = document.getElementById(`formFileSm${index}`) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onFileSelected(event: any, site: any) {
    this.isDisabled = true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      site.selectedFile = selectedFile; // Store the selected file in the site object
      site.FileName = selectedFile.name;
      this.uploadToFTP(selectedFile, site);
    }
  }
  removeFile(site: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to Delete?'
    modalRef.result.then((result: any) => {
      if (result) {
        site.selectedFile = null;
        site.FileName = '';
        const fileInput = document.getElementById(`formFileSm${site.index}`) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
      }
    }).catch(() => {

    });
  }
  viewFile(site: any) {
    if (site.ImageUrl) {
      window.open(site.ImageUrl, '_blank');
    }
    else {
      window.open(site.FileNamelink, '_blank');
    }
    // window.open(site.ImageUrl, '_blank');
  }
  uploadToFTP(file: File, site: any) {
    if (!file) {
      return;
    }
    this.isDisabled = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({
        'DomainName': this.User.Domain,
        'folder': site.DocumentFolderName,
        'CompanyCode': this.User.CompanyCode,
        'FileBase64': reader.result
      }).subscribe((response: any) => {
        if (response.FileName !== "") {
          site.FileName = response.FileName;
          site.ImageUrl = response.Url;
          this.isDisabled = false;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }
  onSelectChange(type: string) {
    if (type === 'Qualification') {
      const selected = this.QualificationLoad.find(duty => duty.QualificationMasterID === this.Filter.QualificationID);
      this.Filter.QualificationName = selected ? selected.QualificationName : null;
    } else if (type == 'relationship') {
      const selected = this.RelationshipLoad.find(site => site.RelationshipMasterID === this.Filter1.RelationshipID);
      this.Filter1.Relationship = selected ? selected.RelationshipName : null;
    } else if (type === 'nomineestate') {
      const selected = this.StateLoad.find(duty => duty.StateMasterID === this.Filter1.StateID);
      this.Filter1.State = selected ? selected.StateName : null;
      this.Filter1.DistrictID = null
      this.Filter1.District = null;
      this.Filter1.TalukaTehsilID = null
      this.Filter1.Taluka = null
      this.NomineeDistrictLoad = [];
      this.NomineeTalukaLoad = [];
    } else if (type === 'nomineedistrict') {
      const selected = this.NomineeDistrictLoad.find(duty => duty.DistrictMasterID === this.Filter1.DistrictID);
      this.Filter1.District = selected ? selected.DistrictName : null;
      this.Filter1.TalukaTehsilID = null
      this.Filter1.Taluka = null
      this.NomineeTalukaLoad = [];
    } else if (type === 'nomineeTaluka') {
      const selected = this.NomineeTalukaLoad.find(duty => duty.TalukaMasterID === this.Filter1.TalukaTehsilID);
      this.Filter1.Taluka = selected ? selected.TalukaName : null;
    } else if (type === 'currentstate') {
      this.CurrentAddress.DistrictID = null;
      this.CurrentAddress.TalukaTehsilID = null;
      this.DistrictLoad = [];
      this.TalukaLoad = []
    } else if (type === 'currentdistrict') {
      this.CurrentAddress.TalukaTehsilID = null;
      this.TalukaLoad = []
    } else if (type === 'permanentstate') {
      this.PermanentAddress.DistrictID = null;
      this.PermanentAddress.TalukaTehsilID = null;
      this.PermanentDistrictLoad = [];
      this.PermanentTalukaLoad = [];
    } else if (type === 'permanentdistrict') {
      this.PermanentAddress.TalukaTehsilID = null;
      this.PermanentTalukaLoad = []
    } else if (type == 'addresstype') {
      const selected = this.AddressTypeLoad.find(site => site.AddressTypeMasterID === this.Filter3.AddressTypeID);
      this.Filter3.AddressTypeName = selected ? selected.AddressTypeName : null;
    } else if (type == 'dependentrelationship') {
      const selected = this.RelationshipLoad.find(site => site.RelationshipMasterID === this.Filter3.RelationshipID);
      this.Filter3.Relationship = selected ? selected.RelationshipName : null;
    } else if (type == 'Bank') {
      const selectedBank = this.Bank.find(bank => bank.bank_master_id === this.BankFormDetail.BankID);
      if (selectedBank) {
        this.acNoLength = selectedBank.AcNoLength;
      } else {
        this.acNoLength = 0;
      }
      this.BankFormDetail.BankBranchID = null;
      this.BankBranch = [];
      this.BankFormDetail.BankAccountNo = null;
      this.ConfirmBankAccountNo = null
      this.BankFormDetail.IFSCcode = null
    } else if (type == 'BankBranch') {
      const selectedBankBranch = this.BankBranch.find(bank => bank.BankBranchMasterID === this.BankFormDetail.BankBranchID);
      this.BankFormDetail.IFSCcode = selectedBankBranch ? selectedBankBranch.IFSCode : null;
    }
  }
  openHistory(type: string) {
    let essEmpProfileUpdateRequestId = null;
    if (type === 'Details') {
      essEmpProfileUpdateRequestId = this.BasicDetail.ESS_EmpProfileUpdateRequestID
    } else if (type === 'CurrentAddress') {
      essEmpProfileUpdateRequestId = this.CurrentAddress.ESS_EmpProfileUpdateRequestID
    } else if (type === 'PermanentAddress') {
      essEmpProfileUpdateRequestId = this.PermanentAddress.ESS_EmpProfileUpdateRequestID
    } else if (type === 'Bank') {
      essEmpProfileUpdateRequestId = this.BankFormDetail.ESS_EmpProfileUpdateRequestID
    } else if (type === 'Qualification') {
      essEmpProfileUpdateRequestId = this.Qualification.ESS_EmpProfileUpdateRequestID
    } else if (type === 'Nominee') {
      essEmpProfileUpdateRequestId = this.Nominee.ESS_EmpProfileUpdateRequestID
    } else if (type === 'Dependent') {
      essEmpProfileUpdateRequestId = this.Dependent.ESS_EmpProfileUpdateRequestID
    } else if (type === 'Document') {
      essEmpProfileUpdateRequestId = this.Document.ESS_EmpProfileUpdateRequestID
    }
    const modalRef = this.modalService.open(ViewProfileRequestDetailComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      OperationType: type,
      EmpMasterId: this.User.UserId,
      ESS_EmpProfileUpdateRequestID: essEmpProfileUpdateRequestId
    };
    modalRef.result.then((result) => {
      if (result) {

      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  validateName(event: KeyboardEvent) {
    const inputValue = event.key;
    const regex = /^[A-Za-z\s]$/;
    if (!regex.test(inputValue)) {
      event.preventDefault();
    }
  }
  validatePincode(event: KeyboardEvent) {
    const inputValue = event.key;
    if (!/^[0-9]$/.test(inputValue)) {
      event.preventDefault();
    }
  }
  onInputChange() {
    this.BasicDetail.FirstName = this.common.ToUpperCase(this.BasicDetail.FirstName);
    this.BasicDetail.MiddleName = this.common.ToUpperCase(this.BasicDetail.MiddleName)
    this.BasicDetail.LastName = this.common.ToUpperCase(this.BasicDetail.LastName)
    this.BasicDetail.FatherHusbandName = this.common.ToUpperCase(this.BasicDetail.FatherHusbandName)

    this.CurrentAddress.LocalAddress1 = this.common.ToUpperCase(this.CurrentAddress.LocalAddress1);
    this.CurrentAddress.LocalAddress2 = this.common.ToUpperCase(this.CurrentAddress.LocalAddress2);
    this.CurrentAddress.VillageCity = this.common.ToUpperCase(this.CurrentAddress.VillageCity);

    this.PermanentAddress.NativeAddress1 = this.common.ToUpperCase(this.PermanentAddress.NativeAddress1);
    this.PermanentAddress.NativeAddress2 = this.common.ToUpperCase(this.PermanentAddress.NativeAddress2);
    this.PermanentAddress.VillageCity = this.common.ToUpperCase(this.PermanentAddress.VillageCity);

    this.Filter.UniversityBoard = this.common.ToUpperCase(this.Filter.UniversityBoard);
    this.Filter.GradeClass = this.common.ToUpperCase(this.Filter.GradeClass);

    this.Filter1.Name = this.common.ToUpperCase(this.Filter1.Name);
    this.Filter1.Address1 = this.common.ToUpperCase(this.Filter1.Address1);
    this.Filter1.Address2 = this.common.ToUpperCase(this.Filter1.Address2);
    this.Filter1.VillageCity = this.common.ToUpperCase(this.Filter1.VillageCity);
    this.Filter1.Guardian = this.common.ToUpperCase(this.Filter1.Guardian);

    this.Filter3.Name = this.common.ToUpperCase(this.Filter3.Name);
  }

  // validatePercentage(event: KeyboardEvent) {
  //   const inputValue = event.key;
  //   if (!/^[0-9]$/.test(inputValue)) {
  //     event.preventDefault();
  //   }

  validatePercentage(event: KeyboardEvent) {
    const inputValue = event.key;
    // Allow numbers, decimal point, and percentage symbol (%)
    if (!/^[0-9.]$/.test(inputValue)) {
      event.preventDefault(); // Prevent invalid characters
      return;
    }
    const currentValue = this.Filter.Percentage;
    // Allow a single decimal point and up to two digits after the decimal
    if (inputValue === '.') {
      // Prevent multiple decimal points
      if (currentValue.includes('.')) {
        event.preventDefault();
      }
    }
  }
  validateShare(event: KeyboardEvent) {
    const inputValue = event.key;
    // Allow numbers, decimal point, and percentage symbol (%)
    if (!/^[0-9.]$/.test(inputValue)) {
      event.preventDefault(); // Prevent invalid characters
      return;
    }
    const currentValue = this.Filter1.Share;
    // Allow a single decimal point and up to two digits after the decimal
    if (inputValue === '.') {
      // Prevent multiple decimal points
      if (currentValue.includes('.')) {
        event.preventDefault();
      }
    }
  }

  onBlurShare() {
    const value = this.Filter1.Share;

    // Check if value is a valid number
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue)) {
      // If it's a valid number, format it to two decimal places
      this.Filter1.Share = numericValue.toFixed(2);
    } else {
      // Handle invalid input, e.g., reset to previous value or show an error
      this.Filter1.Share = '';
      console.error("Invalid input for Share");
    }
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    // alert("Pasting is not allowed.");
  }
}
